import { useQuery } from "@tanstack/react-query";
import { MusicStatistic } from "../types/MusicStatistic";

export function useGetAllMusicStatsForOrganization(organizationId: number) {
    return useQuery<MusicStatistic[]>(
        [`organizations/${organizationId}/music-statistics`],
        {
            refetchOnWindowFocus: false,
        }
    );
}
